import { MapPin, Clock, Navigation, MessageCircle } from "lucide-react";
import { LOCATIONS, waLink } from "../lib/data";

export const Locations = () => {
  return (
    <section
      id="locations"
      data-testid="locations-section"
      className="section-pad bg-white"
    >
      <div className="msc-container">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="badge-trust">Hamari Dukaan</span>
          <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[#1F2937] leading-tight">
            Bhiwandi mein <span className="text-[#1E3A8A]">3 Stores</span>
          </h2>
          <p className="mt-3 text-[#4B5563] text-base sm:text-lg">
            Sabse paas wali shop chunein aur seedha visit karein, ya pehle
            WhatsApp pe pooch lein.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 sm:gap-6">
          {LOCATIONS.map((loc, i) => (
            <div
              key={loc.title}
              data-testid={`location-card-${i}`}
              className="card-base p-6 flex flex-col"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 rounded-xl bg-[#1E3A8A]/10 text-[#1E3A8A] flex items-center justify-center">
                  <MapPin className="w-5 h-5" />
                </div>
                <span className="text-[10px] font-black uppercase tracking-wider text-[#B45309] bg-[#F59E0B]/15 px-2.5 py-1 rounded-full">
                  {loc.badge}
                </span>
              </div>

              <h3 className="font-display font-bold text-lg text-[#1F2937] leading-snug">
                {loc.title}
              </h3>
              <p className="mt-2 text-sm text-[#4B5563] leading-relaxed flex-1">
                {loc.address}
              </p>

              <div className="mt-4 flex flex-col gap-1">
                <div className="inline-flex items-center gap-2 text-xs font-semibold text-[#1F2937]">
                  <Clock className="w-4 h-4 text-[#D97706]" />
                  {loc.timing}
                </div>
                {loc.namazBreak && (
                  <div className="inline-flex items-center gap-2 text-xs font-bold text-[#DC2626]">
                    <Clock className="w-4 h-4 text-[#DC2626]" />
                    {loc.namazBreak}
                  </div>
                )}
              </div>

              <div className="mt-5">
                <a
                  href={loc.map}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`location-map-btn-${i}`}
                  className="btn-primary w-full !px-3 !py-2.5 text-xs sm:text-sm flex justify-center"
                >
                  <Navigation className="w-4 h-4" /> Get Directions
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
